import Base from './Base.vue'
import Overview from './Overview.vue'
import Detail from './Detail.vue'
import FastOrder from './FastOrder.vue'

export default {
    Base,
    Overview,
    Detail,
    FastOrder
}


// WEBPACK FOOTER //
// ./src/views/customer/shop/index.js